/* @flow */
import gql from 'graphql-tag';
import React from 'react';
import ExpandedSearchGroup, {
    fragments as expandedSearchGroupFragments
} from './ExpandedSearchGroup';

import type {Shape as ExpandedSearchGroupShape} from './ExpandedSearchGroup';

import './ExpandedSearchGroups.less';

export type Shape = ExpandedSearchGroupShape[];

export const fragments = {
    hitCollection: gql`
        fragment ExpandedSearchGroupsHitCollection on HitCollection {
            isDatelessSearch
            expandedSearchGroups {
                ...ExpandedSearchGroupExpandedSearchGroup
            }
        }
        ${expandedSearchGroupFragments.expandedSearchGroup}
    `
};

type Props = {
    expandedSearchGroups: Shape,
    isDatelessSearch: boolean,
    onHitMouseEnter: (string) => void,
    onHitMouseLeave: () => void
};

export default function ExpandedSearchGroups({
    onHitMouseEnter,
    onHitMouseLeave,
    expandedSearchGroups,
    isDatelessSearch
}: Props) {
    return (
        <dl className="ExpandedSearchGroups">
            {expandedSearchGroups.map((expandedSearchGroup, i) => (
                <ExpandedSearchGroup
                    key={i}
                    index={i}
                    onHitMouseEnter={onHitMouseEnter}
                    onHitMouseLeave={onHitMouseLeave}
                    isDatelessSearch={isDatelessSearch}
                    expandedSearchGroup={expandedSearchGroup}
                />
            ))}
        </dl>
    );
}
